import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoschUiBackgroundType } from './bosch-ui-background.model';

@Component({
  selector: 'bosch-ui-background',
  imports: [CommonModule],
  templateUrl: './bosch-ui-background.component.html',
  styleUrls: ['./bosch-ui-background.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiBackgroundComponent {
  @Input() type: BoschUiBackgroundType = 'primary';
}
